import { Component, Input, OnInit, Output, EventEmitter } from '@angular/core';
import { version } from 'src/environments/version.prod';

@Component({
  selector: 'headband',
  templateUrl: 'headband.component.html',
  styleUrls: ['./headband.component.less', './../common.less'],
})

export class HeadbandComponent implements OnInit {
  @Input() accountName: string = "";
  @Input() firstname: string = "";
  @Input() lastname: string = "";
  @Input() email: string = "";
  @Input() isClose: boolean = false;
  @Input() isMobile: boolean = false;
  @Input() isTestActive: boolean = false;
  @Input() isValidated: boolean = false;
  @Input() canHaveTestMode = false;
  @Output() testVersionActivated = new EventEmitter<boolean>();

  version = version;

  constructor(
  ) { }

  activateTestVersion() {
    this.testVersionActivated.emit(!this.isTestActive);
  }

  ngOnInit() {
  }
}
